import { motion } from "framer-motion";
import { WHY_ELENTARA } from "@/data/studio";
import { Section, SectionHeading } from "@/components/shared/Primitives";
import { revealStaggered, VIEW_NEAR } from "@/components/shared/motion";

export default function WhyElentara() {
  return (
    <Section id="why" testId="why-section">
      <SectionHeading
        overline="Why Elentara"
        title="Different by construction, not by slogan."
      />
      <div className="mt-16 border-t border-white/10">
        {WHY_ELENTARA.map((item, i) => (
          <motion.div
            key={item.id}
            data-testid={`why-item-${item.id}`}
            variants={revealStaggered}
            initial="hidden"
            whileInView="show"
            viewport={VIEW_NEAR}
            custom={i * 0.08}
            className="grid items-baseline gap-3 border-b border-white/10 py-10 transition-colors duration-500 hover:border-[#8B5CF6]/40 md:grid-cols-[5rem_1fr_1.4fr] md:gap-10"
          >
            <span className="font-mono text-xs tracking-[0.3em] text-[#D4AF37]">{item.id}</span>
            <h3 className="font-display text-lg font-semibold uppercase tracking-tight text-[#F4F6FB] md:text-2xl">
              {item.title}
            </h3>
            <p className="text-sm leading-relaxed text-[#F4F6FB]/55 md:text-base">{item.content}</p>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}
